import * as React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { terms } from "../searchOptions/searchOptions";
import { Currency } from "components/CustomCurrency/currency";
import { Unit } from "components/CustomUnits/units";

import {
  is_search_year_2_years_ago,
  is_search_year_current_year,
  is_search_year_last_year,
} from "../utils";
import MDButton from "components/MDButton";

function createData(nroValue, elem, selectedDetailLevel, selectedData, year) {
  return {
    year: year,
    rank: nroValue,
    company: elem.company,
    companyId: elem.companyId,
    categoryId: "categoryId" in elem ? elem.categoryId : 0,
    lab: elem.lab,
    presentation: elem.presentation,
    selectedDetailLevel: selectedDetailLevel,
    selectedDataType: selectedData === "valores" ? "$" : "",

    periodo_actual:
      selectedData === "valores" ? (
        <Currency value={elem.detailYear} />
      ) : (
        <Unit value={elem.detailYear} />
      ),
    periodo_one_year_ago:
      selectedData === "valores" ? (
        <Currency value={elem.detailOneYearAgo} />
      ) : (
        <Unit value={elem.detailOneYearAgo} />
      ),
    periodo_two_year_ago:
      selectedData === "valores" ? (
        <Currency value={elem.detailTwoYearAgo} />
      ) : (
        <Unit value={elem.detailTwoYearAgo} />
      ),

    participacion_actual: elem.participationYear,
    participacion_one_year_ago: elem.participationOneYearAgo,
    participacion_two_year_ago: elem.participationTwoYearAgo,

    quarters: [
      {
        name: "Primer Trimestre",
        value: <Currency value={elem.detailFirstQuarter} />,
      },
      {
        name: "Segundo Trimestre",
        value: <Currency value={elem.detailSecondQuarter} />,
      },
      {
        name: "Tercer Trimestre",
        value: <Currency value={elem.detailThirdQuarter} />,
      },
      {
        name: "Cuarto Trimestre",
        value: <Currency value={elem.detailFourthQuarter} />,
      },
    ],
  };
}

function Row(props) {
  const { row } = props;
  const [open, setOpen] = React.useState(false);
  const { setSelectedCompanyId } = props;
  const { setSelectedCategoryId } = props;

  return (
    <React.Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell>
          <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row.rank}
        </TableCell>
        {row.selectedDetailLevel === "manufacturer" ? (
          <>
            <TableCell align="left">{row.company}</TableCell>
            <TableCell align="left">{row.presentation}</TableCell>
          </>
        ) : (
          ""
        )}
        {row.selectedDetailLevel === "product" || row.selectedDetailLevel === "presentation" ? (
          <>
            <TableCell align="left">{row.company}</TableCell>
            <TableCell align="left">{row.lab}</TableCell>
            <TableCell align="left">{row.presentation}</TableCell>
          </>
        ) : (
          ""
        )}
        {row.selectedDetailLevel === "company" ? (
          <>
            <TableCell align="left">
              <MDButton
                variant="text"
                color="dark"
                style={{ textAlign: "left" }}
                onClick={() => {
                  setSelectedCompanyId(row.companyId);
                }}
              >
                {row.company}
              </MDButton>
            </TableCell>
          </>
        ) : (
          ""
        )}

        {row.selectedDetailLevel === "category" ? (
          <>
            <TableCell align="left">
              <MDButton
                variant="text"
                color="dark"
                style={{ textAlign: "left" }}
                onClick={() => setSelectedCategoryId(row.categoryId)}
              >
                {row.presentation}
              </MDButton>
            </TableCell>
          </>
        ) : (
          ""
        )}

        {is_search_year_current_year(row.year) ? (
          <>
            <TableCell align="left">{row.periodo_two_year_ago}</TableCell>
            <TableCell align="left">{row.periodo_one_year_ago}</TableCell>
            <TableCell align="left">{row.periodo_actual}</TableCell>

            <TableCell align="left">{row.participacion_two_year_ago}%</TableCell>
            <TableCell align="left">{row.participacion_one_year_ago}%</TableCell>
            <TableCell align="left">{row.participacion_actual}%</TableCell>
          </>
        ) : (
          <></>
        )}
        {is_search_year_last_year(row.year) ? (
          <>
            <TableCell align="left">{row.periodo_two_year_ago}</TableCell>
            <TableCell align="left">{row.periodo_actual}</TableCell>
            <TableCell align="left">{row.periodo_one_year_ago}</TableCell>

            <TableCell align="left">{row.participacion_two_year_ago}%</TableCell>
            <TableCell align="left">{row.participacion_actual}%</TableCell>
            <TableCell align="left">{row.participacion_one_year_ago}%</TableCell>
          </>
        ) : (
          <></>
        )}
        {is_search_year_2_years_ago(row.year) ? (
          <>
            <TableCell align="left">{row.periodo_actual}</TableCell>
            <TableCell align="left">{row.periodo_one_year_ago}</TableCell>
            <TableCell align="left">{row.periodo_two_year_ago}</TableCell>

            <TableCell align="left">{row.participacion_actual}%</TableCell>
            <TableCell align="left">{row.participacion_one_year_ago}%</TableCell>
            <TableCell align="left">{row.participacion_two_year_ago}%</TableCell>
          </>
        ) : (
          <></>
        )}
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography variant="h6" gutterBottom component="div">
                Todo el Año
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead style={{ display: "contents" }}>
                  <TableRow>
                    <TableCell>Trimestre</TableCell>
                    <TableCell>Value</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row.quarters.map((quartersRow) => (
                    <TableRow key={quartersRow.name}>
                      <TableCell component="th" scope="row">
                        {quartersRow.name}
                      </TableCell>
                      <TableCell align="left">{quartersRow.value}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

Row.propTypes = {
  setSelectedCompanyId: PropTypes.func,
  setSelectedCategoryId: PropTypes.func,
  row: PropTypes.shape({
    year: PropTypes.number.isRequired,
    rank: PropTypes.number.isRequired,
    company: PropTypes.string,
    lab: PropTypes.string,
    presentation: PropTypes.string.isRequired,
    selectedDetailLevel: PropTypes.string,
    selectedDataType: PropTypes.string,

    periodo_actual: PropTypes.string,
    periodo_one_year_ago: PropTypes.string.isRequired,
    periodo_two_year_ago: PropTypes.string.isRequired,

    participacion_actual: PropTypes.string.isRequired,
    participacion_one_year_ago: PropTypes.string.isRequired,
    participacion_two_year_ago: PropTypes.string.isRequired,

    companyId: PropTypes.number.isRequired,
    categoryId: PropTypes.number,

    quarters: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        value: PropTypes.number.isRequired,
      })
    ).isRequired,
  }).isRequired,
};

function prettyColumn(columnLabel, bgColor) {
  return {
    bgColor: bgColor,
    column: columnLabel,
  };
}
export default function MarketAnalysisTable({
  data,
  params,
  setSelectedCompanyId,
  setSelectedCategoryId,
}) {
  //   param data: [    {
  //     "presentation": "PRONACA",
  //     "company": "PRONACA",
  //     "companyId": 3907,
  //     "detailYear": 3186075,
  //     "detailOneYearAgo": 2882799,
  //     "detailTwoYearAgo": 109248,
  //     "participationYear": 39,
  //     "participationOneYearAgo": 34,
  //     "participationTwoYearAgo": 2,
  //     "growthRateYear": 0,
  //     "growthRateOneYearAgo": 2500,
  //     "detailFirstQuarter": 3186075,
  //     "detailSecondQuarter": 3112533,
  //     "detailThirdQuarter": 0,
  //     "detailFourthQuarter": 0
  // }]
  let columns = [prettyColumn("Rank", "white")];

  if (params.selectedDetailLevel === "company") {
    columns.push(prettyColumn("Empresa", "white"));
  }

  if (params.selectedDetailLevel === "manufacturer") {
    columns.push(prettyColumn("Empresa", "white"));
    columns.push(prettyColumn("Laboratorio", "white"));
  }

  if (params.selectedDetailLevel === "product") {
    columns.push(prettyColumn("Empresa", "white"));
    columns.push(prettyColumn("Laboratorio", "white"));
    columns.push(prettyColumn("Producto", "white"));
  }

  if (params.selectedDetailLevel === "category") {
    columns.push(prettyColumn("Categoria", "white"));
  }

  if (params.selectedDetailLevel === "presentation") {
    columns.push(prettyColumn("Empresa", "white"));
    columns.push(prettyColumn("Laboratorio", "white"));
    columns.push(prettyColumn("Presentacion", "white"));
  }

  let two_year_difference = 0;
  let one_year_difference = 0;
  let search_year = 0;

  let totales = null;

  if (is_search_year_current_year(params.year)) {
    two_year_difference = Number(params.year) - 2;
    one_year_difference = Number(params.year) - 1;
    search_year = Number(params.year);

    columns.push(prettyColumn(two_year_difference, "whitesmoke"));
    columns.push(prettyColumn(one_year_difference, "whitesmoke"));
    columns.push(prettyColumn(search_year, "whitesmoke"));

    columns.push(prettyColumn(two_year_difference, "silver"));
    columns.push(prettyColumn(one_year_difference, "silver"));
    columns.push(prettyColumn(search_year, "silver"));

    totales = {
      periodo_two_year_diff: 0,
      periodo_one_year_diff: 0,
      periodo_actual: 0,
    };
  }
  if (is_search_year_last_year(params.year)) {
    two_year_difference = Number(params.year) - 1;
    one_year_difference = Number(params.year) + 1;
    search_year = Number(params.year);

    columns.push(prettyColumn(two_year_difference, "whitesmoke"));
    columns.push(prettyColumn(search_year, "whitesmoke"));
    columns.push(prettyColumn(one_year_difference, "whitesmoke"));

    columns.push(prettyColumn(two_year_difference, "silver"));
    columns.push(prettyColumn(search_year, "silver"));
    columns.push(prettyColumn(one_year_difference, "silver"));

    totales = {
      periodo_two_year_diff: 0,
      periodo_actual: 0,
      periodo_one_year_diff: 0,
    };
  }
  if (is_search_year_2_years_ago(params.year)) {
    two_year_difference = Number(params.year) + 2;
    one_year_difference = Number(params.year) + 1;
    search_year = Number(params.year);

    columns.push(prettyColumn(search_year, "whitesmoke"));
    columns.push(prettyColumn(one_year_difference, "whitesmoke"));
    columns.push(prettyColumn(two_year_difference, "whitesmoke"));

    columns.push(prettyColumn(search_year, "silver"));
    columns.push(prettyColumn(one_year_difference, "silver"));
    columns.push(prettyColumn(two_year_difference, "silver"));

    totales = {
      periodo_actual: 0,
      periodo_one_year_diff: 0,
      periodo_two_year_diff: 0,
    };
  }

  let rows = [];

  data.forEach((elem, index) => {
    rows.push(
      createData(index + 1, elem, params.selectedDetailLevel, params.selectedData, params.year)
    );

    totales.periodo_two_year_diff += elem.detailTwoYearAgo;
    totales.periodo_one_year_diff += elem.detailOneYearAgo;
    totales.periodo_actual += elem.detailYear;
  });

  return (
    <TableContainer component={Paper}>
      <Table aria-label="collapsible table">
        <TableHead style={{ display: "contents" }}>
          {/* first table header row */}
          <TableRow>
            <TableCell align="left" />
            {[...Array(columns.length - 6).keys()].map((e) => {
              return <TableCell key={e} align="left" />;
            })}
            <TableCell align="center" colSpan={3} bgColor="whitesmoke">
              {terms.filter((elem) => elem.id === params.selectedTerms).pop().name}
            </TableCell>
            <TableCell align="center" colSpan={3} bgColor="silver">
              % Participación
            </TableCell>
          </TableRow>
          {/* second table header row */}
          <TableRow>
            <TableCell align="left" />
            {columns.map((column, index) => (
              <TableCell key={index} align="left" bgColor={column.bgColor}>
                {column.column}
              </TableCell>
            ))}
          </TableRow>
          {/* third table header row */}
          <TableRow>
            <TableCell align="left" />

            <TableCell align="left" colSpan={columns.length - 6}>
              Totales
            </TableCell>

            {Object.keys(totales).map((key, index) => (
              <TableCell key={index + "total"} align="left">
                {params.selectedData === "valores" ? (
                  <Currency value={totales[key]} />
                ) : (
                  <Unit value={totales[key]} />
                )}
              </TableCell>
            ))}

            {["100%", "100%", "100%"].map((key, index) => (
              <TableCell key={index + "total"} align="left">
                {key}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <Row
              key={row.name}
              row={row}
              setSelectedCompanyId={setSelectedCompanyId}
              setSelectedCategoryId={setSelectedCategoryId}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
MarketAnalysisTable.defaultProps = {
  data: [],
  params: {},
  setSelectedCompanyId: null,
  setSelectedCategoryId: null,
};

MarketAnalysisTable.propTypes = {
  data: PropTypes.array,
  params: PropTypes.object,
  setSelectedCompanyId: PropTypes.func,
  setSelectedCategoryId: PropTypes.func,
};
